export default function riskTypeDirective() {
  return {
    template: require('./risk-type.html'),
    restrict: 'E',
    controller: 'RiskTypeController',
    controllerAs: 'riskTypeVM',
    tooltipAppendToSelector: '@',
    bindToController: true,
    replace: true,
    scope: {
      riskType: '=',
      showAssign: '<',
      showUnassign: '<',
      showEdit: '<',
      assignedAssetType: '<',
      showDelete: '<',
      tooltipAppendToSelector: '@',
      assetType: '<',
    },
  };
}
